import { render, staticRenderFns } from "./tablePrp.vue?vue&type=template&id=0b79f1ea"
import script from "./tablePrp.vue?vue&type=script&lang=js"
export * from "./tablePrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports